// Ids no mesmo formato que o servidor aceita (`row_ab12cd34`).
export const newId = prefix =>
  `${prefix}_${Math.random().toString(16).slice(2, 10).padEnd(8, '0')}`;
